module.exports = __webpack_public_path__ + "static/media/icon_to.cb0861e4.svg";